/*
 * Customize selectable widget
 * This snippet modifies the prototype of the $.ui.selectable, hence it is moved
 * to outside of link function to be run only once.
 */ 
$.widget( "ui.selectable", $.ui.selectable, {
    _mouseStart: function(event) {
        // execute default _mouseStart method
        this._super(event);
        // run customize code
        // set lasso slightly off the place so that mouse event (e.g. double click)
        // can be emitted with correct "target" value
        this.helper.css( {
            "left": event.pageX + 2,
            "top": event.pageY + 2,
            "width": 0,
            "height": 0
        } );
        // selectable widget absorbs click event. Emit a mocked click event on the parent element
        // of the selectable element so that the click chain may continue.
        this.element.closest('.ui-selectable').parent().click();
    }
});

(function () {
    'use strict';

    angular.module('GorillaBoy.directives')
    .directive('multiSelect', ['$timeout', '$rootScope', '$log', 'SignalProvider', '$document', 'ClientMetricsService', 'AppConstants', function($timeout, $rootScope, $log, SignalProvider, $document, ClientMetricsService, AppConstants) {
        // suppress deselection from these places 1. top action bar 2. uib dialog 3. selectable element itself
        var SUPPRESS_DESELECT_IDENTIFIERS = 'action-bar, .modal-dialog, .ui-selectable, .select-box';
        function getResourceInfo ($element) {
            var type = 'unknown';

            // Ensure element has jQuery-like functionality
            $element = $($element);


            if ($element.hasClass('file')) {
                type = AppConstants.ResourceTypes.FILE;
            } else if ($element.hasClass('folder')) {
                type = AppConstants.ResourceTypes.FOLDER;
            } else if ($element.hasClass('task')) {
                type = AppConstants.ResourceTypes.TASK;
            }

            return {
                type: type,
                id: $element.data('id')
            };
        }

        return {
            scope: {
                selectionManager: '=multiSelect'
            },
            link: function (scope, element, attrs) {
                if (scope.selectionManager === undefined) {
                    $log.error('[FATAL] multiSelect initialization failed because no selectionManager is provided!');
                    return;
                }
                 /**
                 * Triggered once for each newly selected element.
                 */
                function onElementSelected (event, ui) {
                    var ResourceInfo = getResourceInfo(ui.selected);
                    //Hide the dropdown that's open so that only one option is shown at a time
                    //SIM https://issues.amazon.com/issues/WORKDOCS-2666
                    //$("#browse-files .dropdown.open button.dropdown-toggle").click();
                    $rootScope.$evalAsync(function() {
                        ClientMetricsService.addClickToSession('file-browser-view-lasso-selection');
                        scope.selectionManager.markAsSelected(ResourceInfo.type, ResourceInfo.id);
                    });
                    
                }

                /**
                 * Triggered once for each element that was previously selected that no longer is.
                 * Note: this event is fired prior to the `selected` event.
                 */
                function onElementUnselected (event, ui) {
                    $rootScope.$evalAsync(function() {
                        var ResourceInfo = getResourceInfo(ui.unselected);
                        scope.selectionManager.unselect(ResourceInfo.type, ResourceInfo.id);
                    });
                }

                $timeout(function () {
                    $(element).selectable({
                        filter: 'li',
                        // Ensure we don't block events on hyperlinks (i.e. don't perform Selectable work when an anchor tag is clicked)
                        cancel: 'a,.select-box,.icons .btn-group, .action-bar-clickable, .action-bar-not-clickable',                        
                        selected: onElementSelected,
                        unselected: onElementUnselected
                    });
                }, 0, false);

                /*
                // The commented code allows user to deselect when click on elements that are not
                // selectable. Uncomment the code below if the feature is needed.
                $document.on('click', deselectFiles);
                scope.$on('$destroy', function() {
                    $document.off('click', deselectFiles);
                });

                function deselectFiles($event) {     
                    if ($event.target && ($($event.target).closest(SUPPRESS_DESELECT_IDENTIFIERS).length>0)) {
                        return;
                    }

                    $(element).find('.ui-selected').removeClass('ui-selected');
                    $rootScope.$evalAsync(function() {
                        scope.selectionManager.clearSelected();
                    });
                }
                */
            }
        };
    }]);
}());
